import { render } from "./DinnerAvailability.vue?vue&type=template&id=6c10743c&scoped=true"
import script from "./DinnerAvailability.vue?vue&type=script&lang=js"
export * from "./DinnerAvailability.vue?vue&type=script&lang=js"

import "./DinnerAvailability.vue?vue&type=style&index=0&id=6c10743c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c10743c"]])

export default __exports__